<template>
    <div>
        <el-form :inline="true" :model="condition" label-width="150px">
            <el-form-item>
                <el-input v-model="condition.id" style="width: 300px;" placeholder="账号"/>
            </el-form-item>
            <el-form-item>
                <el-select v-model="condition.walletType" placeholder="钱包账户类型">
                    <el-option v-for="item in walletTypes" :key="item.code" :value="item.code" :label="item.desc"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="condition.snapshot" type="datetime" placeholder="选择余额快照时间" value-format="timestamp"/>
            </el-form-item>
            <el-form-item>
                <el-input v-model="condition.businessType" placeholder="交易类型"/>
            </el-form-item>
            <el-form-item>
                <el-button @click="queryInfo()" type="primary">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="font-size: medium;margin-bottom: 10px;">
            <el-row>
                <el-col :span="14"><span style="font-weight: bold">当前余额信息</span></el-col>
                <el-col :span="2"> 平账账户ID：</el-col>
                <el-col :span="8">
                    <el-input placeholder="输入平账用户ID" v-model="poiseUserId"></el-input>
                </el-col>
            </el-row>
        </div>
        <el-table :data="currentBalance">
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column label="当前可用余额">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.coinAmount"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="当前冻结余额">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.coinFroze"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="设置余额">
                <template slot-scope="scope">
                    <el-button @click="setBalanceMess(scope.row,scope.$index)">余额设置</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="font-size: medium;margin-top: 20px;margin-bottom: 10px;font-weight: bold">快照余额信息</div>
        <el-table :data="balanceSnapInfo">
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column prop="coinAmount" label="快照可用余额"></el-table-column>
            <el-table-column prop="coinFroze" label="快照冻结余额"></el-table-column>
        </el-table>

        <div style="font-size: medium;margin-top: 20px;margin-bottom: 10px;font-weight: bold">用户未完成订单</div>
        <div style="font-size: medium;margin-top: 20px;margin-bottom: 10px;">
            <el-form :inline="true">
                <el-form-item label="交易对">
                    <el-input placeholder="请输入交易对" v-model="pair"></el-input>
                </el-form-item>
                <el-form-item label="钱包类型">
                    <el-select v-model="walletType" placeholder="请选择">
                       <el-option v-for="item in walletTypes" :key="item.code" :value="item.code" :label="item.desc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单类型">
                    <el-select v-model="orderType" placeholder="请选择">
                        <el-option v-for="item in orderTypes" :key="item.code" :value="item.code" :label="item.desc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="买卖方向">
                    <el-select v-model="direction" placeholder="请选择">
                        <el-option v-for="item in directions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序方式">
                    <el-select v-model="sortingWay" placeholder="请选择">
                        <el-option v-for="item in sortingWays" :key="item.code" :value="item.code" :label="item.desc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryOrder(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="unFinishOrder">
            <el-table-column label="订单编号" prop="id"></el-table-column>
            <el-table-column label="方向" prop="direction"></el-table-column>
            <el-table-column label="订单类型" prop="orderType"></el-table-column>
            <el-table-column label="订单来源" prop="src"></el-table-column>
            <el-table-column label="成交量" prop="dealAmount"></el-table-column>
            <el-table-column label="总量" prop="totalAmount"></el-table-column>
            <el-table-column label="冻结量" prop="frozenAmountByOrder"></el-table-column>
            <el-table-column label="锚定币种金额" prop="totalAnchorCoin"></el-table-column>
            <el-table-column label="价格" prop="price"></el-table-column>
            <el-table-column label="基准费率" prop="feeRate"></el-table-column>
            <el-table-column label="状态" prop="status"></el-table-column>
            <el-table-column label="创建时间" prop="createdTime"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button round type="warning" @click="removeOrder(scope.row.id)">取消订单</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalUnFinishOrder" :page-size="10" :current-page="pageUnFinishOrder"
                       @current-change="queryOrder"></el-pagination>

        <div style="font-size: medium;margin-top: 20px;margin-bottom: 10px;font-weight: bold">用户活期宝撤销</div>
        <el-form :inline="true">
            <el-form-item label="用户ID">
                <el-input v-model="PledgeInfo.userId"></el-input>
            </el-form-item>
            <el-form-item label="币种">
                <el-input v-model="PledgeInfo.coinType"></el-input>
            </el-form-item>
            <el-form-item label="金额">
                <el-input v-model="PledgeInfo.amount"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="pledgeHandle()">取消活期宝</el-button>
            </el-form-item>
        </el-form>

        <div style="font-size: medium;margin-top: 20px;margin-bottom: 10px;font-weight: bold">账单信息</div>
        <el-table :data="billInfo">
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="businessType" label="交易类型"></el-table-column>
            <el-table-column prop="businessKey" label="交易KEY"></el-table-column>
            <el-table-column prop="userRole" label="用户角色"></el-table-column>
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
            <el-table-column prop="availableAmountChange" label="可用余额变更"></el-table-column>
            <el-table-column prop="frozenAmountChange" label="冻结余额变更"></el-table-column>
            <el-table-column prop="businessTime" label="交易时间" :formatter="dateFormat">
            </el-table-column>
            <el-table-column prop="resultCode" label="交易结果"></el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalBill" :page-size="25" :current-page="pageNo"
                       @current-change="changePage"></el-pagination>

    </div>
</template>

<script>
    import './store';
    import {mapState, mapActions} from 'vuex';
    import moment from 'moment';
    import api from './api';

    export default {
        name: "tradeException",

        data() {
            return {
                condition: {
                    id: '',
                    snapshot: '',
                    businessType: '',
                    walletType: '',
                },
                poiseUserId: '',
                currentBalance: [],
                pair: '',
                pageNo:1,
                direction : '',
                directions : [
                    {value : 'BID', label : '买方向'},
                    {value : 'ASK', label : '卖方向'}
                ],
                walletType:'WALLET',
                walletTypes:[{code:'WALLET',desc:'现货账户'},{code:'MARGIN',desc:'杠杆账户'},
                    {code:'CONTRACT',desc:'合约账户'},{code:'GENERAL',desc:'超级合约账户'},{code:'OTC',desc:'法币账户'}],
                orderType:'',
                orderTypes:[{code:'',desc:'全部'},{code:'LIMIT',desc:'限价单'},{code:'STOP_LIMIT',desc:'止盈止损'}],
                pageUnFinishOrder:1,
                sortingWay:'TIME_DESC',
                sortingWays:[{code:'TIME_DESC',desc:'时间降序'},{code:'TIME_ASC',desc:'时间升序'},{code:'PRICE_ASC',desc:'价格升序'},{code:'PRICE_DESC',desc:'价格降序'}],
                PledgeInfo:{userId:'',coinType:'',amount:''}
            }
        },

        computed: {
            ...mapState('tradeException', ['balanceInfo', 'billInfo', 'balanceSnapInfo', 'unFinishOrder','totalBill','totalUnFinishOrder'])
        },

        methods: {
            ...mapActions('tradeException', ['getBalanceInfo', 'getBillInfo', 'setBalance', 'getSnapBalanceInfo', 'queryUnFinishOrder', 'cancelUserOrder']),
            setBalanceMess(row, index) {
                let data = {
                    id: row.userId,
                    coinType: row.coinType,
                    avAmount: row.coinAmount,
                    frAmount: row.coinFroze,
                    oldAvAmount: this.balanceInfo[index].coinAmount,
                    oldFrAmount: this.balanceInfo[index].coinFroze,
                    poiseUserId: this.poiseUserId
                }
                this.setBalance(data).then(() => {
                    this.getBalanceInfo(this.condition);
                    this.$message({type: 'success', message: '重置余额成功'});
                })
            },

            dateFormat(row, column) {
                return moment(row.businessTime).format("YYYY-MM-DD HH:mm:ss")
            },

            queryInfo() {
                this.getBalanceInfo(this.condition);
                this.getSnapBalanceInfo(this.condition);
                this.getBillInfo(this.condition)
            },

            /** 撤销订单 */
            removeOrder(orderNo) {
                let data = {
                    userId: this.condition.id,
                    pair: this.pair,
                    orderNo: orderNo
                };
                this.cancelUserOrder(data).then( () => {
                    this.$message({type:'success',message:'撤销订单成功'});
                    this.queryOrder(1);
                })
            },

            /**查询订单*/
            queryOrder(val){
                this.pageUnFinishOrder = val;
                let data = {
                    userId:this.condition.id,
                    pair: this.pair,
                    direction : this.direction,
                    walletType: this.walletType,
                    orderType: this.orderType,
                    page:this.pageUnFinishOrder,
                    sortingWay:this.sortingWay
                };
                this.queryUnFinishOrder(data);
            },

            changePage() {
                let data = {
                    id: this.condition.id,
                    tableNo: this.condition.tableNo,
                    businessType: this.condition.businessType,
                    page: this.pageNo
                }
                this.getBillInfo(data);
            },

            pledgeHandle(){
                api.pledgeUnLock(this.PledgeInfo).then(()=>{
                    this.$message.success('活期宝取消成功');
                })
            }

        },

        watch: {
            balanceInfo(val) {
                this.currentBalance = JSON.parse(JSON.stringify(val));
            }
        }

    }
</script>

<style scoped>

</style>
